import _ from 'lodash';
import numeral from 'numeral';
import React from 'react';
import { Table } from 'grab-ui';
import { CAMPAIGN_METRICS_CHART_CONFIG } from '../../constants/ucd';

const CampaignCommsMetricsTable = ({ metrics }) => {
  const cellRender = (value, format = '0,0') => {
    return value ? numeral(value).format(format) : 'N.A';
  };

  const columns = [
    {
      title: 'Channel',
      dataIndex: 'channelName',
      key: 'channelName',
      render: (text) =>
        _.get(CAMPAIGN_METRICS_CHART_CONFIG, `${text}.displayText`, text),
    },
    {
      title: 'Sent',
      dataIndex: 'sent',
      key: 'sent',
      render: (value) => cellRender(value),
    },
    {
      title: 'Received',
      dataIndex: 'received',
      key: 'received',
      render: (value) => cellRender(value),
    },
    {
      title: 'Clicked',
      dataIndex: 'notifclick',
      key: 'notifclick',
      render: (value) => cellRender(value),
    },
    {
      title: 'Opened',
      dataIndex: 'open',
      key: 'open',
      render: (value) => cellRender(value),
    },
    {
      title: 'CTA Clicked',
      dataIndex: 'ctaclick',
      key: 'ctaclick',
      render: (value) => cellRender(value),
    },
    {
      title: 'Open Rate (Push)',
      dataIndex: 'rates.notifclickRate',
      key: 'rates.notifclickRate',
      render: (value) => cellRender(value, '0.00 %'),
    },
    {
      title: 'Open Rate',
      dataIndex: 'rates.openRate',
      key: 'rates.openRate',
      render: (value) => cellRender(value, '0.00 %'),
    },
    {
      title: 'Click-Through Rate',
      dataIndex: 'rates.ctaclickRate',
      key: 'rates.ctaclickRate',
      render: (value) => cellRender(value, '0.00 %'),
    },
  ];

  const data = _.map(metrics, (channelData, channelName) => {
    return {
      channelName,
      ...channelData,
    };
  });

  return <Table pagination={false} dataSource={data} columns={columns} />;
};

export default CampaignCommsMetricsTable;
